import ApplicationModel, { attr } from '../ApplicationModel';
import { type ReleaseDateHistoryAttributes } from './generated/ReleaseDateHistoryAttributes';
import { model } from '../modelBuilder';

interface ReleaseDateHistory extends ReleaseDateHistoryAttributes {}

@model
class ReleaseDateHistory extends ApplicationModel {
  // Start auto-generated
  static typename: 'ReleaseDateHistory' = 'ReleaseDateHistory';
  get typename(): 'ReleaseDateHistory' {
    return 'ReleaseDateHistory';
  }

  static fields = {
    changedFrom: attr({ readable: true }),
    changedOn: attr({ readable: true }),
    changedTo: attr({ readable: true }),
    title: attr({ readable: true }),
    changedBy: attr.belongsTo({ readable: true, typename: 'User' }),
  };
  // End auto-generated
}

export default ReleaseDateHistory;
